import * as actionTypes from 'actions';

const initialState = {
  compatibilityGroup: {},
  participantSummary: {},
  eventCounts: [],
  objectTypes: [],
  objectOfInterestSubjectAreas: [],
  overview: {},
  eventUserValidationCounts: [],
  scenarioEventCounts: [],
  loading: false,
  createdTime: null,
  periodEventCounts: [],
  trainingCompatibilityGroups: []
};

const trainingDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FIND_LATEST_TRAINING_SESSION_SUMMARY_PENDING: {
      return {
        ...initialState,
        trainingCompatibilityGroups: state.trainingCompatibilityGroups,
        loading: true
      };
    }

    case actionTypes.FIND_LATEST_TRAINING_SESSION_SUMMARY_FULFILLED: {
      const summary = action.payload.data.result;

      return {
        ...state,
        ...action.payload.data.result,
        trainingCompatibilityGroups: state.trainingCompatibilityGroups,
        loading: false
      };
    }

    case actionTypes.CREATE_TRAINING_SESSION_SUMMARY_PENDING: {
      return {
        ...state,
        loading: true,
        creating: true
      };
    }

    case actionTypes.CREATE_TRAINING_SESSION_SUMMARY_FULFILLED: {
      const summary = action.payload.data.result;

      return {
        ...state,
        ...action.payload.data.result,
        trainingCompatibilityGroups: state.trainingCompatibilityGroups,
        loading: false,
        creating: false
      };
    }

    case actionTypes.FIND_TRAINING_COMPATIBILITY_GROUPS_FULFILLED: {
      return {
        ...state,
        trainingCompatibilityGroups: action.payload.data.result
      };
    }

    default: {
      return state;
    }
  }
};

export default trainingDashboardReducer;
